// test2660
(2660 && 0);
